import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as angular from "angular";
import { NotifyService } from "../services/notify-service";
import { AssetService } from "../services/asset-service";
import { RLEntityAssetsTableController } from "./entity-assets-table";

RLEntityAssetsTableRow.$inject = ["$compile"];
export function RLEntityAssetsTableRow($compile: ng.ICompileService) {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/entity-assets-table-row.html"),
        controller: RLEntityAssetsTableRowController,
        controllerAs: "eatrVM",
        require: ["^rlEntityAssetsTable", "rlEntityAssetsTableRow"],
        bindToController: true,
        scope: {
            row: "=",
            childCount: "=",
            level: "="
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ctrls: [RLEntityAssetsTableController, RLEntityAssetsTableRowController]) => {
            var childrenConstructed = false;
            ctrls[1].tableCtrl = ctrls[0];
            ctrls[1].compileChildren = () => {
                if (!childrenConstructed) {
                    var templateElement = angular.element(`<tr ng-if="eatrVM.open" rl-entity-assets-table-row  ng-repeat="childRow in eatrVM.childRows" row="childRow" child-count="eatrVM.childRowChildCounts[childRow.record.recordID]" level="eatrVM.childLevel"></tr>
                                                                <tr rl-entity-assets-table-row-ops="" class="info" ng-if="eatrVM.isLoading || (eatrVM.showMore && eatrVM.open)"></tr>`);
                    var compiled = $compile(templateElement);

                    element.after(templateElement);
                    compiled(scope);
                    childrenConstructed = true;
                }
            };
        }
    };
    return directive;
}

class RLEntityAssetsTableRowController {
    static $inject = ["$scope", "notifyService", "assetService"];

    tableCtrl: RLEntityAssetsTableController;

    arrowClass: string;
    childCount: number;
    childLevel: number;
    childRowChildCounts: { [key: number]: number };
    childRows: Models.IRecordRelationshipPair[];
    childRowsNumFound: number;
    compileChildren: Function;
    isLoading: boolean;
    level: number;
    loadedPages: { [key: number]: boolean };
    open: boolean;
    page: number;
    row: Models.IRecordRelationshipPair;
    showMore: boolean;

    constructor(private $scope: ng.IScope, private notifyService: NotifyService, private assetService: AssetService) {

        this.arrowClass = "fa-caret-right";
        this.childLevel = this.level + 1;
        this.childRowChildCounts = {};
        this.childRows = [];
        this.childRowsNumFound = 0;
        this.isLoading = false;
        this.loadedPages = {};
        this.open = false;
        this.page = 1;
        this.showMore = false;

        this.$scope.$watch(() => this.open,
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    this.arrowClass = newValue ? "fa-caret-down" : "fa-caret-right";
                }
            });
    }

    Toggle($event: ng.IAngularEvent) {
        $event.preventDefault();
        if (!this.open) {
            if (this.compileChildren != null) {
                this.compileChildren();
            }
            if (this.loadedPages[this.page] !== true) {
                this.LoadPage();
            }
        }
        this.open = !this.open;
    }

    LoadPage() {
        this.isLoading = true;
        this.notifyService.startProgress();
        this.assetService.searchEntityAssets(this.tableCtrl.parentEntityID, this.row.record.recordID, this.page, 20)
            .then((results) => {

                this.childRows = Array.prototype.concat(this.childRows, results.assets);
                this.childRowsNumFound = results.numFound;
                this.childRowChildCounts = results.assetChildCounts;
                this.showMore = this.childRowsNumFound > this.childRows.length;
                this.loadedPages[this.page] = true;
            }, this.notifyService.errorResponseHandler)
            .finally(() => {
                this.notifyService.endProgress();
                this.isLoading = false;
            });
    }

    ShowMore($event: ng.IAngularEvent) {
        $event.preventDefault();

        this.page += 1;
        this.LoadPage();
    }
}